export default "__VITE_ASSET__n61z8CPt__"